import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import MarkdownIt from 'markdown-it';

const Wrapper = styled.div`
  max-height: ${props => props.maxHeight};
  overflow: ${props => props.scrollable ? 'auto' : 'hidden'};
  margin: ${props => props.margin};
`;

export const textDisplayStyles = /*css*/`
  table {
    width: 100% !important;
    max-width: 100%;
    margin-bottom: 20px;
    border-spacing: 0px !important;
    border: 1px solid #ccc;
    background: #fff;
    margin: 0;
  }
  tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
  }
  tr {
    background: #fff;
  }
  th {
    font-size: 12px;
    text-align: left;
    padding: 3px 8px;
    color: white;
    background: #929292;
  }
  td {
    padding: 8px;
  }
  td, th {
    text-align: left;
    border: 1px solid #ddd;
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid #ddd;
  }
  img {
    max-width: 400px;
    max-height: 400px;
    border-radius: 10px;
  }
  a {
    text-decoration: underline;
  }
  p {
    text-align: left;
  }
  ul {
    margin-left: 20px;
  }
  ul li {
    list-style-type: disc;
    margin-bottom: 0px;
  }
`;

const TextDisplay = observer(props => {
  const shadowHostRef = useRef(null);
  const mdRef = useRef(new MarkdownIt());

  const formatNewline = string => {
    return string.replace(/\\r/g, '<br />');
  };

  const getHtmlSource = () => {
    if (props.htmlText) {
      return props.htmlText;
    } else if (props.markdown) {
      return formatNewline(mdRef.current.enable(['newline']).render(props.markdown));
    }
    return null;
  };

  useEffect(() => {
    const shadowHost = shadowHostRef.current;
    if (!shadowHost) return;

    let shadowRoot = shadowHost.shadowRoot;
    if (!shadowRoot) {
      shadowRoot = shadowHost.attachShadow({ mode: 'open' });
    }

    const htmlSource = getHtmlSource();
    if (htmlSource) {
      shadowRoot.innerHTML = `
        <style>
          ${textDisplayStyles}
        </style>
        <div>${htmlSource}</div>
      `;
    }
  }, [props.htmlText, props.markdown]);

  return (
    <Wrapper
      maxHeight={props.maxHeight}
      scrollable={props.scrollable}
      margin={props.margin}
    >
      <div ref={shadowHostRef}></div>
    </Wrapper>
  );
});

export default ErrorBoundary(TextDisplay);
